import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Link, Paper, Switch, Typography, Box, Accordion, AccordionSummary, AccordionDetails, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useSnackbar } from 'notistack';
import { eventToggleApi, getFleetAlertListApi, getUserApi, mailTemplateApi, updateUserApi } from '../apiService';
import MailConfigurationModal from '../components/MailConfigurationModal';
import "../../assets/styles/_alert_notifications.scss"
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus, getGlobalCookie } from '../../../utils';
import { PageLoader, STableLoader } from '../../../shared_elements';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { trackActivity } from '../../../utils/mixpanel';
import { getAssetListApi } from '../../../shared_elements/actionCreators';
import { PermissionWrapper } from '../../../wrappers';
import SettingPageLayout from '../../elements/SettingPageLayout';
import { RoleBaseAccess } from '../../../hoc';

const FleetAlertNotification = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar()
  const { assetList, permission } = useSelector((state) => state.leases);
  const alertPermission = permission?.permissions?.lease_revamp_application?.lease_revamp?.alert_n_notification;
  const hasAlertEditPermission = Array.isArray(alertPermission) ? alertPermission.includes('U') : false;
  const [mailConfig, setMailConfig] = useState({ modal: false, })
  const [alertInfo, setAlertInfo] = useState([])
  const [userInfo, setUserInfo] = useState([])
  const [isLoading, setLoading] = useState({ skeletonLoader: true, buttonLoader: false, pageLoader: false });
  const [dropDownLoader, setDropDownLoader] = useState({ userList: false, assetList: false })
  const [mailData, setMailData] = useState({})
  const [error, setError] = useState({})
  let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess')) || {};
  const operationObj = {
    "create": "C",
    "update": "U",
    "delete": "D",
    "export": "EXP"
  }

    useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Fleet Alert & Notifications' })
    if (!assetList?.length) {
          setDropDownLoader(prev => ({ ...prev, assetList: true }));
          dispatch(getAssetListApi({ setIsDropDownLoading:setDropDownLoader }));
        }
    getAlertList("skeletonLoader");
  }, [])

  const onFieldChange = (key, value) => { setMailData((prev) => ({ ...prev, [key]: value })); };
  const onFocusChange = (keyParam) => { setError((prev) => ({ ...prev, [keyParam]: '' })) }
  const getAlertList = (loaderType) => {
    loaderType === 'skeletonLoader' ? setLoading({ skeletonLoader: true }) : setLoading({ pageLoader: true });
    if (lessorAccess?.id) {
      globalGetService(getFleetAlertListApi(lessorAccess?.id)).then(response => {
        if (checkApiStatus(response)) {
          loaderType === 'skeletonLoader' ? setLoading({ skeletonLoader: false }) : setLoading({ pageLoader: false });
          setAlertInfo(response.data.data);
        } else {
          loaderType === 'skeletonLoader' ? setLoading({ skeletonLoader: false }) : setLoading({ pageLoader: false });
        }
      })
    }
  };

  const getUserList = (moduleKey, operatioKey) => {
    setDropDownLoader({...dropDownLoader,userList:true})
    globalGetService(getUserApi(moduleKey, operationObj[operatioKey])).then(response => {
      setDropDownLoader({...dropDownLoader,userList:false})
      if (checkApiStatus(response)) {
        setUserInfo(response.data.data)
      } else {
        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
      }
    })
  }
  const getMailTemplate = (eventId) => {
    setLoading({ pageLoader: true })
    globalGetService(mailTemplateApi(eventId)).then(response => {
      setLoading({ pageLoader: false })
      if (checkApiStatus(response)) {
        setMailData({ ...mailData, subject: response?.data?.data?.subject, body: response?.data?.data?.body })
      }
    })
  };
  const onEditUser = (eventId) => {
    const payload = { user_ids: mailData?.user_ids?.map(user => user?.user_id && Number(user.user_id)), lessor_id: lessorAccess?.id }
    const validationInputs = {
      user_ids: mailConfig.mode === "addUser" && (!mailData?.user_ids || mailData?.user_ids?.length <= 0) ? "Please select User(s)" : ""
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading({ buttonLoader: true })
      globalPutService(updateUserApi(eventId), payload).then(response => {
        setLoading({ buttonLoader: false })
        if (checkApiStatus(response)) {
          onToggleModal()
          getAlertList("pageLoader")
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Users`, success_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Users`, error_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
        }
      })
    } else {
      setError(validationInputs);
    }
  };
  const onEditMailTemplate = (eventId) => {
    setLoading({ buttonLoader: true })
    const payload = { subject: mailData?.subject, body: mailData?.body, lessor_id: lessorAccess?.id }
    globalPutService(mailTemplateApi(eventId), payload).then(response => {
      setLoading({ buttonLoader: false })
      if (checkApiStatus(response)) {
        onToggleModal()
        getAlertList("pageLoader")
        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Mail Template`, success_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
      } else {
        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        trackActivity('Item Edited', { page_title: `Edit Alert & Notifications Mail Template`, error_msg: response?.data?.message, item_id: eventId, payload, response: response?.data })
      }
    })
  };
  const onToggleModal = () => { setMailConfig({ data: null, modal: false, mode: null, checked: false, mailTemplateId: null, eventTypeId: null, moduleKey: null, operatioKey: null }); setUserInfo(null); setMailData({}); setError({}) }
  const onEventToggle = (status, eventTypeId) => {
    const validationInputs = {
      user_ids: mailConfig.mode === "enable" && (!mailData?.user_ids || mailData?.user_ids?.length <= 0) ? "Please select User(s)" : "",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      status ? setLoading({ buttonLoader: true }) : setLoading({ pageLoader: true })
      const assetScope = (mailData?.asset_scope || []).map((asset) => ({
        asset_type: asset?.asset_type,
        asset_id: asset?.asset_id || asset?.id,
      }));
      const payload = status ? {
        ...mailData,
        enabled: true,
        user_ids: mailData?.user_ids?.map(user => user.user_id),
        lessor_id: lessorAccess?.id,
        asset_scope: assetScope,
      } : {lessor_id: lessorAccess?.id, enabled: false };
      globalPutService(eventToggleApi(eventTypeId), payload).then((response) => {
        if (checkApiStatus(response)) {
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          getAlertList("pageLoader")
          onToggleModal()
          trackActivity('Item Edited', { page_title: `${status ? 'Enable' : 'Disable'} Alert Event`, success_msg: response?.data?.message, item_id: eventTypeId, payload, response: response?.data })
        } else {
          setLoading({ ...isLoading, buttonLoader: false, pageLoader: false })
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `${status ? 'Enable' : 'Disable'} Alert Event`, error_msg: response?.data?.message, item_id: eventTypeId, payload, response: response?.data })
        }
      });
    } else {
      setError(validationInputs);
    }
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Alert & Notifications`, page_type: page_type, })
  }

  return (
    <SettingPageLayout>
      <Paper className='alert-notification-container' sx={{ maxHeight: 'calc(100vh - 145px)', boxShadow: "0px 0px 1px 1px #BBBBBB" }}>
        {isLoading?.skeletonLoader ? (<STableLoader count={4} rowCount={10} />) : alertInfo?.length > 0 ? alertInfo?.map((moduleItem, index) => {
          return (
            <Accordion elevation={2} square disableGutters key={index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                <Typography className='alert-notification-title' color='primary'>{moduleItem?.name}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: '0px', marginBottom: '15px' }}>
                <Grid container marginLeft={2} marginRight={2} spacing={2}>

                  <Grid size={{ md: 12,xs:12 }}>
                  <Table className="mui-table-format" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" sx={{ width: "140px" }}>Event</TableCell>
                        <TableCell align="center" sx={{ width: "140px" }}>Enable / Disable</TableCell>
                        <TableCell align="left" sx={{ width: "140px" }}>Notify User(s)</TableCell>
                        <TableCell align="left" sx={{ width: "140px" }}>Mail Template</TableCell>
                        <TableCell align="left" sx={{ width: "140px" }}>Asset(s)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {moduleItem?.event_types?.map((item) => (
                        <TableRow key={item?.id} className="alert-notification-body">
                          <TableCell> {item?.name} </TableCell>
                          <TableCell align="center">
                              <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "alert_n_notification", operationType: ['C', 'U'] }}
                                noPermissionChild={
                                  <Switch size="small" checked={item?.enabled} disabled />
                                }>
                                <Switch
                                size="small"
                                checked={item?.enabled}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setMailConfig({
                                      modal: true,
                                      eventTypeId: item?.id,
                                      moduleKey: moduleItem?.module_key,
                                      operatioKey: item?.operation_key,
                                      mode: "enable",
                                      checked: true,
                                    });
                                    getUserList(
                                      moduleItem?.module_key,
                                      item?.operation_key
                                    );
                                    handleItemClicked(`${item?.name || ""} Enable Switch`)
                                  } else {
                                    onEventToggle(false, item?.id);
                                    handleItemClicked(`${item?.name || ""} Disable Switch`)
                                  }
                            }}
                                />
                              </PermissionWrapper>
                          </TableCell>
                          <TableCell>
                            {item?.enabled &&
                              <Box sx={{ opacity: 1, cursor: "pointer", }} >
                                <Link
                                  sx={{ pointerEvents: "auto" }}
                                  onClick={() => {
                                    setMailConfig({
                                      modal: true,
                                      eventTypeId: item?.id,
                                      mode: "addUser",
                                      moduleKey: moduleItem?.module_key,
                                      operatioKey: item?.operation_key,
                                    });
                                    setMailData((prev) => ({
                                      ...prev,
                                      user_ids: item?.notify_users,
                                    }));
                                    getUserList(
                                      moduleItem?.module_key,
                                      item?.operation_key
                                    );
                                    handleItemClicked(`${item?.name || ""} ${item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} User(s)`)
                                  }}
                                >
                                  {item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} User(s)
                                </Link>
                                {item?.enabled && item?.notify_users?.length > 0 && (<sup style={{ fontSize: "10px" }}> ({item.notify_users.length}) </sup>)}
                              </Box>}
                          </TableCell>
                          <TableCell>
                            {item?.enabled &&
                              <Box sx={{ opacity: 1, cursor: "pointer", }} >
                                <Link
                                  sx={{ pointerEvents: "auto" }}
                                  onClick={() => {
                                    setMailConfig({
                                      modal: true,
                                      eventTypeId: item?.id,
                                      mailTemplateId: item?.mail_template?.id,
                                      mode: "addTemplate",
                                    });
                                    getMailTemplate(item?.mail_template?.id);
                                    handleItemClicked(`${item?.name || ""} ${item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} Mail Template`)
                                  }}
                                >
                                  {item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} Mail Template
                                </Link>
                              </Box>}
                          </TableCell>
                          <TableCell>
                            {item?.enabled &&
                              <Box sx={{ opacity: 1, cursor: "pointer", }} >
                                <Link
                                  sx={{ pointerEvents: "auto" }}
                                  onClick={() => {
                                    setMailConfig({
                                      modal: true,
                                      eventTypeId: item?.id,
                                      mode: "addAsset",
                                      moduleKey: moduleItem?.module_key,
                                      operatioKey: item?.operation_key,
                                      checked:true
                                    });
                                    setMailData((prev) => ({
                                      ...prev,
                                      user_ids: item?.notify_users,
                                      asset_scope: item?.asset_scope,
                                    }));
                                    handleItemClicked(`${item?.name || ""} ${item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} Asset(s)`)
                                  }}
                                >
                                  {item?.enabled ? (hasAlertEditPermission ? "Edit" : "View") : "Add"} Asset(s)
                                </Link>
                                {item?.enabled && item?.asset_scope?.length > 0 && (<sup style={{ fontSize: "10px" }}> ({item.asset_scope.length}) </sup>)}
                              </Box>}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          )
        }) : <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", fontSize: "20px", fontWeight: "bold" }}>No Record Found</Typography>}
      </Paper>
      {mailConfig?.modal ? <MailConfigurationModal isLoading={isLoading} mailConfig={mailConfig} mailData={mailData} userInfo={userInfo} dropDownLoader={dropDownLoader?.userList} error={error} onEventToggle={onEventToggle} onEditUser={onEditUser} onEditMailTemplate={onEditMailTemplate} onFieldChange={onFieldChange} onFocusChange={onFocusChange} onToggleModal={onToggleModal} assetList={assetList} type='fleet' isAssetListLoading={dropDownLoader?.assetList} disableFields={!hasAlertEditPermission} /> : null}
      {isLoading?.pageLoader ? <PageLoader /> : null}
    </SettingPageLayout>
  )
}

export default RoleBaseAccess(FleetAlertNotification, { application: 'lease_revamp', feature: 'alert_n_notification', operationType: ['R'], settingNav: true });
